import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=62c1848b&scoped=true&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"
import style0 from "./Items.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Items.vue?vue&type=style&index=1&id=62c1848b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c1848b",
  null
  
)

export default component.exports